export default __webpack_public_path__ + "static/image-mv_cases-25af945ff0384f6603cf514e365e15b3.jpg";